import { useMemo } from "react";

// Rank products by how often this employee has requested them. Recency is
// only a tie-breaker: the rail is meant to make repeat ordering faster.
function buildOrderStats(requests, user) {
  const stats = new Map();
  if (!user) return stats;

  (requests || []).forEach((request) => {
    if (request.requestedBy !== user.id || request.type === "internal_transfer") return;
    const requestedAt = new Date(request.createdAt).getTime();
    (request.items || []).forEach((item) => {
      const current = stats.get(item.productId) || { orderCount: 0, lastRequestedAt: null };
      current.orderCount += 1;
      if (!Number.isNaN(requestedAt) && (!current.lastRequestedAt || requestedAt > current.lastRequestedAt)) {
        current.lastRequestedAt = requestedAt;
      }
      stats.set(item.productId, current);
    });
  });

  return stats;
}

export function usePriorityProducts(products, requests, user, limit = 6) {
  return useMemo(() => {
    if (!products?.length || !user) return [];
    const stats = buildOrderStats(requests, user);

    return products
      .map((product) => ({
        product,
        orderCount: stats.get(product.id)?.orderCount || 0,
        lastRequestedAt: stats.get(product.id)?.lastRequestedAt || null,
      }))
      .filter((item) => item.orderCount > 0)
      .sort((a, b) =>
        b.orderCount - a.orderCount ||
        (b.lastRequestedAt || 0) - (a.lastRequestedAt || 0) ||
        a.product.name.localeCompare(b.product.name)
      )
      .slice(0, limit);
  }, [products, requests, user, limit]);
}
